head.ready('appJS', function(){
  $(document).ready(function(){
      $('ac-overlay').each(function(){
        if($(this).attr('data-width')){
          if($(this).attr('data-width')!=''){
            $(this).children().css({'max-width':$(this).attr('data-width')+'px'});
          }
        }
        var ih = 'initial';
        if($(this).attr('data-iframe-height')!=''){
            ih = $(this).attr('data-iframe-height') + 'px';
        }else{
            ih = 'initial';
        }
        if($(this).attr('data-iframesrc')){
          if($(this).attr('data-iframesrc')!=''){
            $(this).find('ac-overlay-content').css({"height":ih,"overflow":"hidden"}).addClass('padnone-all');
          }
        }   
      });
      $('ac-overlay').on('click', function(e){
        e.preventDefault();
        if($(this).attr('data-clickoutside')!='false'){
          $(this).removeClass('shown');
        }
      });
      $('ac-overlay > *').on('click', function(e){
        e.stopPropagation();
      });

      angelCake.acOverlay = {};
      angelCake.acOverlay.show = function(elemID){
        
        var target = $('#'+elemID);
        if(target.attr('data-iframesrc')){
          if(target.attr('data-iframesrc')!=''){
            if(!target.data('iframecontent')){  
              target.data('iframecontent','<iframe scrolling="yes" frameborder="0" style="height:100%;" src="'+target.attr('data-iframesrc')+'"></iframe>');
              target.find('ac-overlay-content').html(target.data('iframecontent'));
            }
          }
        }
        target.addClass('shown'); 
        window.setTimeout(function(){
          window.dispatchEvent(new Event('resize'));
        }, 300);
      };
      angelCake.acOverlay.hide = function(elemID){
        var target = $('#'+elemID);
        target.removeClass('shown'); 
      };


      $('[data-open-overlay').on('click',function(e){
        e.stopPropagation();
        angelCake.acOverlay.show($(this).attr('data-open-overlay'));
      });

      $('[data-close-overlay').on('click',function(e){
        e.stopPropagation();
        angelCake.acOverlay.hide($(this).attr('data-close-overlay'));
      });

    });
  });